import {ProgressHeaderWithPopup} from "../components/progressHeaderWithPopup"
import { HeadLogo } from "../components/headLogo";
import { LocationImageDisplay } from "../components/locationImageDisplay"; 


function NotArrivedView({ onGoBack, onProceed, locationTitle, imageKey,  onBack }) {

 
    
    return (
      <div className="arrivalCheck_container">
        <HeadLogo/>
        <ProgressHeaderWithPopup currentStep={1} onBack={onGoBack} />

        <div className="global-screen-content">
          {/* Sassy Header */}
          <div className="global-question_screen-question-text">
            <div>
              How Dare You 😤
            </div>
          </div>
  
          {/* Body Text */}
          <div className="global-question_screen-question-text" style={{ fontWeight: "400", fontSize: "24px", marginTop: "16px", marginBottom: "16px" }}>
            You haven’t even arrived at <div className="global-question_screen-highlight"style={{ display: 'inline' }}>{locationTitle}</div> and you're trying to move on?
          </div>
  
          {/* Buttons */}
          <div className="global-ctabutton-vertical">
            <button 
              className="global-main_calltoaction_btn" 
              onClick={onGoBack}
              >
              Go Back
            </button>
            <button 
               className="global-main_calltoaction_btn inverse" 
               onClick={onProceed}
            >
              Risk It!
            </button>
          </div>
        </div>       
       <div>
        <LocationImageDisplay imageKey={imageKey} />
        </div>
    </div>
    );
  }
  
  export { NotArrivedView };
  
  
  
  